import React from 'react';

export default class NotFound extends React.Component {
  render() {
    return (
      <div data-testid="page-not-found">
        <span>not found page</span>
      </div>
    );
  }
}
